const { MQTT_ONLY_DEVICE_SETTINGS } = require('../../js/constants')

angular
  .module('surfsightApp.controllers')
  .controller('organizationSettingsController', [
    '$scope',
    '$rootScope',
    '$log',
    '$state',
    '$timeout',
    '$interval',
    '$location',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    'edgeFactory',
    'leafletData',
    function (
      $scope,
      $rootScope,
      $log,
      $state,
      $timeout,
      $interval,
      $location,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      $mdColors,
      edgeFactory,
      leafletData
    ) {
      const $translate = $filter('translate')
      $scope.cancel = function () {
        $mdDialog.cancel()
      }
      $scope.themePrimary = $mdColors.getThemeColor('primary')
      $scope.themeAccent = $mdColors.getThemeColor('accent')
      $scope.showMessageToast = function (message) {
        const toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('top right')
          .hideDelay(5000)
          .actionKey('F1')
        $mdToast
          .show(toast)
          .then(function (response) {
            if (response == 'ok') {
              //
            }
          })
          .catch(() => {})
      }
      $scope.isOrganizationProfileEnabled = null
      const request_json = {
        method: 'GET',
        url:
          V2_BASEURL +
          `/organizations/${$localStorage.currentUserOrganization.id}`
      }
      $http(request_json)
        .then(res => {
          if (
            res.data &&
            res.data.data &&
            res.data.data.isOrganizationProfileEnabled !== undefined
          )
            $scope.isOrganizationProfileEnabled =
              res.data.data.isOrganizationProfileEnabled
        })
        .catch(ex => {
          $scope.showMessageToast($translate('errorOccurred'))
          console.error('Error:', ex)
        })

      $scope.toggleOrganizationProfile = () => {
        const newValue = !$scope.isOrganizationProfileEnabled
        const data = { isOrganizationProfileEnabled: newValue }
        const request_json = {
          method: 'PATCH',
          url:
            V2_BASEURL +
            `/organizations/${$localStorage.currentUserOrganization.id}`,
          data
        }
        $http(request_json)
          .then(res => {
            $scope.isOrganizationProfileEnabled = newValue
          })
          .catch(ex => {
            $scope.showMessageToast($translate('errorOccurred'))
            console.error('Error:', ex)
          })
      }

      $scope.openEditDeviceSettings = () => {
        $mdDialog
          .show({
            controller: 'organizationDeviceSettingsEditController',
            templateUrl:
              './templates/organization-device-settings-edit.view.html?t=' +
              window.webpackHash,
            clickOutsideToClose: true,
            locals: {
              isOrgDeviceSettings: true
            },
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(data => {
            Object.values(data).forEach(o => delete o.allowInBulk)
            if ($localStorage.isOrgAllDevicesAI12) {
              MQTT_ONLY_DEVICE_SETTINGS.forEach(setting => delete data[setting])
            }
            const request_json = {
              method: 'POST',
              url:
                V2_BASEURL +
                `/organizations/${$localStorage.currentUserOrganization.id}/device-settings`,
              data
            }
            $http(request_json)
              .then(res => {
                $scope.showMessageToast($translate('dataUpdatedSuccessfully'))
              })
              .catch(ex => {
                $scope.showMessageToast($translate('configErrorOccurred'))
                console.error('Error:', ex)
              })
          })
          .catch(() => {})
      }
      $scope.openEditEventsSettings = () => {
        $mdDialog
          .show({
            controller: 'organizationEventsSettingsEditController',
            templateUrl:
              './templates/organization-events-settings-edit.view.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(data => {
            data.events = data.events.filter(e => e.dataType != 'off')
            const request_json = {
              method: 'POST',
              url:
                V2_BASEURL +
                `/organizations/${$localStorage.currentUserOrganization.id}/event-settings`,
              data
            }
            $http(request_json)
              .then(res => {
                $scope.showMessageToast($translate('dataUpdatedSuccessfully'))
              })
              .catch(ex => {
                $scope.showMessageToast($translate(ex.data.message))
                console.error('Error: ', ex)
              })
          })
          .catch(() => {})
      }
      $scope.openEditWebhooksSettings = () => {
        $mdDialog
          .show({
            controller: 'organizationWebhooksSettingsEditController',
            templateUrl:
              './templates/organization-webhooks-settings-edit.view.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(data => {
            const request_json = {
              method: 'POST',
              url:
                V2_BASEURL +
                `/organizations/${$localStorage.currentUserOrganization.id}/webhook-settings`,
              data
            }
            $http(request_json)
              .then(res => {
                $scope.showMessageToast($translate('dataUpdatedSuccessfully'))
              })
              .catch(ex => {
                $scope.showMessageToast($translate('configErrorOccurred'))
                console.error('Error:', ex)
              })
          })
          .catch(() => {})
      }
      $scope.openEditRetentionSettings = () => {
        $mdDialog
          .show({
            controller: 'organizationRetentionSettingsEditController',
            templateUrl:
              './templates/organization-retention-settings-edit.view.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(data => {
            const request_json = {
              method: 'PATCH',
              url:
                V2_BASEURL +
                `/organizations/${$localStorage.currentUserOrganization.id}`,
              data
            }
            $http(request_json)
              .then(res => {
                $scope.showMessageToast($translate('dataUpdatedSuccessfully'))
              })
              .catch(ex => {
                $scope.showMessageToast($translate('configErrorOccurred'))
                console.error('Error:', ex)
              })
          })
          .catch(() => {})
      }
      $scope.openEditDataProfileSettings = () => {
        $mdDialog
          .show({
            controller: 'organizationDataProfileSettingsEditController',
            templateUrl:
              './templates/organization-data-profile-settings-edit.view.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(data => {
            const request_json = {
              method: 'PUT',
              url:
                V2_BASEURL +
                `/organizations/${$localStorage.currentUserOrganization.id}/data-profile`,
              data
            }
            $http(request_json)
              .then(res => {
                $scope.showMessageToast($translate('dataUpdatedSuccessfully'))
              })
              .catch(ex => {
                $scope.showMessageToast($translate('configErrorOccurred'))
                console.error('Error:', ex)
              })
          })
      }
      $scope.openEditOrganizationPrivacySettings = () => {
        $mdDialog
          .show({
            controller: 'organizationDefaultPrivacySettingsEditController',
            templateUrl:
              './templates/organization-default-privacy-settings-edit.view.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(data => {
            const request_json = {
              method: 'PATCH',
              url:
                V2_BASEURL +
                `/organizations/${$localStorage.currentUserOrganization.id}/privacy-config`,
              data
            }
            $http(request_json)
              .then(res => {
                $scope.showMessageToast($translate('dataUpdatedSuccessfully'))
              })
              .catch(ex => {
                $scope.showMessageToast($translate('configErrorOccurred'))
                console.error('Error:', ex)
              })
          })
      }
      $scope.showFamiliarDriver = function () {
        $mdDialog.cancel()
        $state.go('home.common.settings.familiarDriver')
      }
      $scope.isRestrictedUser =
        $localStorage.userDetails.accessLevel === 'viewer'
      const userDetails = $localStorage.userDetails
      const dataProfileAllowedUserTypes = ['reseller', 'reseller-contact']
      $scope.allowDataProfileAccess =
        userDetails.super_admin ||
        dataProfileAllowedUserTypes.includes(userDetails.type)
    }
  ])
